import SquaberTVQuotationNotifier from "../TradingView/SquaberTVQuotationNotifier";
import SquaberTVShapeManager from "../TradingView/SquaberTVShapeManager";
import TVDataFeed from "../TradingView/TVDataFeed";
import { getTvChartBridgeIntervals } from "./buildTvChartBridgeInitPayload";

export default function createTvChartBridgeDataFeed({
  stock,
  tvChartRoutinePromiseCreator,
  translate,
  latestQuoteDatetimeUtc
}) {
  const shapes = {};
  const shapeManager = new SquaberTVShapeManager(shapes, stock);
  const intervals = getTvChartBridgeIntervals(stock);

  const dataFeed = new TVDataFeed(
    stock,
    tvChartRoutinePromiseCreator,
    new SquaberTVQuotationNotifier(stock.id, false),
    shapeManager,
    translate,
    intervals,
    latestQuoteDatetimeUtc
  );

  dataFeed.getShapesSnapshot = () => shapes;
  dataFeed.shapeManager = shapeManager;

  return dataFeed;
}
